import {
  ADD_PAGE,
  CLEAR_PAGES,
  DELETE_PAGE,
  MOVE_BACK,
  MOVE_FIRST,
  MOVE_LAST,
  MOVE_NEXT,
  MOVE_TO,
  SETUP_PAGINATION
} from "./constants";

export function setupPagination(key) {
  return {
    type: SETUP_PAGINATION,
    payload: {
      key
    }
  };
}

export function addPage(key, pageOrdered, meta) {
  return {
    type: ADD_PAGE,
    payload: {
      pageOrdered,
      meta,
      key
    }
  };
}

export function deletePage(key, pageNumber) {
  return {
    type: DELETE_PAGE,
    payload: {
      pageNumber,
      key
    }
  };
}

export function clearPages(key) {
  return {
    type: CLEAR_PAGES,
    payload: {
      key
    }
  };
}

export function moveTo(key, page) {
  return {
    type: MOVE_TO,
    payload: {
      key,
      page
    }
  };
}

export function moveNext(key) {
  return {
    type: MOVE_NEXT,
    payload: {
      key
    }
  };
}

export function moveBack(key) {
  return {
    type: MOVE_BACK,
    payload: {
      key
    }
  };
}

export function moveLast(key) {
  return {
    type: MOVE_LAST,
    payload: {
      key
    }
  };
}

export function moveFirst(key) {
  return {
    type: MOVE_FIRST,
    payload: {
      key
    }
  };
}
